import { any, array, boolean, create, Describe, object, optional, record, string, type } from 'superstruct';

import { FormResponse } from '~modules/media-library/model/RaiseRequestFormSettings';

const Field = object({
  key: string(),
  name: string(),
  type: string(),
  label: string(),
  value: optional(string()),
  required: boolean(),
  options: optional(record(string(), any())),
  display_condition: optional(string()),
  disabled: optional(boolean()),
});

const RaiseRequestFormValidator = object({
  fields: array(Field),
});

export const RaiseRequestAssetsValidator = RaiseRequestFormValidator;

export function makeRaiseRequest(raw) {
  try {
    const validatedData = create(raw, RaiseRequestAssetsValidator);
    return validatedData;
  } catch (err) {
    console.error('Validation error:', err);
    return null;
  }
}

export const FormResponseValidator: Describe<FormResponse> = type({
  status: optional(string()),
  form_errors: optional(record(string(), any())),
});

export function makeFormResponse(raw: unknown) {
  try {
    const formResponse = create(raw, FormResponseValidator);
    return formResponse;
  } catch (err) {
    console.error(err);
  }
}
